import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=660eed22&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=660eed22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660eed22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('660eed22')) {
      api.createRecord('660eed22', component.options)
    } else {
      api.reload('660eed22', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=660eed22&scoped=true&", function () {
      api.rerender('660eed22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2EJuELUrBuqLr/JS/comp/PopupBox.vue"
export default component.exports